import React from 'react';
import styles from './WatchListStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    color: 'darkgrey',
    padding: 0,
    width: 6,
    height: 0,
  },
});
const FavouroiteTickerTable = ({ favTicker, setfavTicker, favLoading }) => {
  const classes = useStyles();
  const setChekboxes = (data, index) => {
    let newCh = JSON.parse(JSON.stringify(favTicker));
    newCh[index].value = !favTicker[index].value;
    setfavTicker(newCh);
  };
  return favLoading ? (
    <CircularProgress
      style={styles.circularSpinner}
      size={20}
      color="primary"
    />
  ) : (
    <Table style={{ tableLayout: 'fixed' }}>
      <TableBody style={styles.tableBody}>
        {favTicker &&
          favTicker.map((row, index) => {
            return (
              <TableRow style={{ ...styles.tableRow }} key={index}>
                <TableCell
                  colSpan={4}
                  style={{ ...styles.modalTableRowFavouriteTable }}
                  align="center"
                >
                  {row.name}
                </TableCell>
                <TableCell
                  colSpan={2}
                  style={{ ...styles.modalTableRowFavouriteTable }}
                  align="center"
                >
                  <Checkbox
                    checked={row.value}
                    onClick={() => setChekboxes(row, index)}
                    classes={{ root: classes.root }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

export default FavouroiteTickerTable;



// WEBPACK FOOTER //
// ./src/Pages/WatchList/favouriteTickerTable.js